import { Link, useNavigate } from "react-router-dom";
import "./headerMain.css";
import "./header.css";
import { useContext, useEffect, useState } from "react";
import { cartContext } from "../../App";
import Cookies from "js-cookie";
import DeliveryTime from "../subcomponents/deliveryTime";
import { Player } from "@lottiefiles/react-lottie-player";
import headerBg from "../../assets/header/freslo-header-bg-2.jpg";
import AiOrb from "../subcomponents/aiOrb/AiOrb";

export default function HeaderMain() {
    const navigate = useNavigate();
    const { CartItem, selectedAddress } = useContext(cartContext);
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [showStickySearch, setShowStickySearch] = useState(false);
    const displayAddress = selectedAddress
        ? selectedAddress?.address?.addressLine2.slice(0, 25) + "..."
        : "Select Address";

    useEffect(() => {
        const handleScroll = () => {
            setShowStickySearch(window.scrollY > 160);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    function close() {
        setShowDownloadButton(false);
    }

    return (
        <div className="header-main-container">
            {showStickySearch && (
                <div className="sticky-search-container">
                    <Link to="/search" style={{ textDecoration: "none" }}>
                        <div className="header-main-container-bottom sticky-search">
                            <img
                                src="/find.png"
                                alt="search"
                                className="header-main-search-logo"
                            />

                            <p className="header-main-search-text">
                                Search for <b>"Sugar"</b>
                            </p>
                        </div>
                    </Link>
                </div>
            )}
            {showDownloadButton && (
                <div className="header-main-app-logo">
                    <div className="header-main-app-logo-container">
                        <img
                            className="header-main-app-close-btn"
                            src="/icons/close.png"
                            alt="close-btn"
                            onClick={close}
                        />

                        <img
                            className="header-main-app-logo-img"
                            src="/ic_launcher_rounded.png"
                            alt="logo"
                        />

                        <p className="header-main-app-name">freslo App</p>
                    </div>

                    <div className="header-main-app-logo-container-right">
                        <Link
                            to="https://play.google.com/store/apps/details?id=com.otu_android"
                            style={{
                                textDecoration: "none",
                            }}
                        >
                            <p className="header-main-install-btn">INSTALL</p>
                        </Link>
                    </div>
                </div>
            )}

            <div
                className="header-main-bg"
                style={{
                    backgroundImage: `url(${headerBg})`,
                }}
            >
                <div className="header-main-container-top">
                    <div className="header-main-container-top-left">
                        <div>
                            <DeliveryTime />

                            <div className="address-container">
                                <Link to="/address-list" className="address">
                                    {displayAddress} ▼
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="header-main-container-top-right">
                        <div>
                            <Link to="/cart">
                                <div className="cart-item-number">
                                    <span className="item-number">
                                        {CartItem.length}
                                    </span>

                                    <img
                                        className="cart-logo"
                                        src="/shopping-cart.png"
                                        alt="cart"
                                    />
                                </div>
                            </Link>
                        </div>

                        <div>
                            <Link to="/hamburger-menu">
                                <div
                                    className="open-icon"
                                    style={{ margin: "5px" }}
                                ></div>
                                <div
                                    className="open-icon"
                                    style={{ margin: "5px" }}
                                ></div>
                                <div
                                    className="open-icon"
                                    style={{ margin: "5px" }}
                                ></div>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="header-main-search-wrapper">
                    <Link to="/search" className="header-main-search-link">
                        <div className="header-main-container-bottom">
                            <div className="header-main-search-left">
                                <img
                                    src="/find.png"
                                    alt="search"
                                    className="header-main-search-logo"
                                />

                                <p className="header-main-search-text">
                                    Search for <b>"Sugar"</b>
                                </p>
                            </div>

                            <AiOrb
                                variant="compact"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.location.href = "/ai-assistant";
                                }}
                            />
                        </div>
                    </Link>
                </div>

                <div
                    className="header-main-banner-title-container"
                    style={{
                        position: "relative",
                        overflow: "hidden",
                        height: "120px",
                        marginTop: "20px",
                    }}
                >
                    <Player
                        autoplay
                        loop
                        src="/lottie-files/sale.json"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 0,
                        }}
                    />

                    <div
                        style={{
                            position: "relative",
                            zIndex: 1,
                            textAlign: "center",
                            padding: "20px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    ></div>
                </div>

                <div className="header-main-container-banner">
                    <Link
                        to="/display-products"
                        state={{
                            category: "pooja-essentials",
                            name: "Puja Essentials",
                        }}
                        className="header-main-container-banner-content"
                    >
                        <img
                            className="header-main-container-banner-img"
                            src="/main-banner/box-puja-items.jpg"
                            alt="banner"
                        />
                        <p className="header-main-container-banner-text">
                            Puja Items
                        </p>
                    </Link>

                    <Link
                        to="/display-products"
                        state={{
                            category: "fruits,exotics",
                            name: "Fruits",
                        }}
                        className="header-main-container-banner-content"
                    >
                        <img
                            className="header-main-container-banner-img"
                            src="/main-banner/fresh-fruits.jpg"
                            alt="banner"
                        />
                        <p className="header-main-container-banner-text">
                            Fresh Fruits
                        </p>
                    </Link>

                    <Link
                        to="/display-products"
                        state={{
                            category: "vegetables,vegetables-others",
                            name: "Vegetables",
                        }}
                        className="header-main-container-banner-content"
                    >
                        <img
                            className="header-main-container-banner-img"
                            src="/main-banner/fresh-vegetables.jpg"
                            alt="banner"
                        />
                        <p className="header-main-container-banner-text">
                            Fresh Vegetables
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    );
}
